import { render, staticRenderFns } from "./Gain1View.vue?vue&type=template&id=04a4e6ea&scoped=true"
import script from "./Gain1View.vue?vue&type=script&lang=js"
export * from "./Gain1View.vue?vue&type=script&lang=js"
import style0 from "./Gain1View.vue?vue&type=style&index=0&id=04a4e6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a4e6ea",
  null
  
)

export default component.exports